const EVENT = {
  COOKIE_BANNER_SKIPPED_BY_COUNTRY: 'cookieBannerSkippedByCountry',
  FINDER_CHANGE: 'finderChange',
  FINDER_LOADED: 'finderLoaded',
  SET_STORE: 'setStore',
};

export { EVENT };
